import {View} from 'backbone';
import React from 'react';
import ReactDOM, {render} from 'react-dom';
import {default as SearchBar} from '@sinclair-digital/sbg-storyline-components/src/components/SearchBar';
import {bindAllMethods} from '../../backboneHelpers';

export default View.extend({
    el: '#package-basic-search',
    initialize({type, showAdvancedFilters = true, searchOptions}) {
        this.templateData = {type};
        this.showAdvancedFilters = showAdvancedFilters;
        this.searchOptions = searchOptions;
        this.listenTo(searchOptions, 'change', this.render);
        this.onSearch = query => {
            // change event must be triggered manually since the search options might not have changed
            this.searchOptions.set(query, {silent: true});
            this.searchOptions.trigger('change');
        };
        this.onChangeQuery = query => {
            // update must be silent otherwise a search will be triggered
            this.searchOptions.set(query, {silent: true});
            this.render();
        };

        bindAllMethods(this);
        this.render();
    },
    render() {
        const query = this.searchOptions.toJSON();
        query.searchText = query.searchText || {
            filterType: 'searchbar',
            filters: [],
            groupName: 'Search',
            text: '',
        };

        render(
            <SearchBar
                placeholderText={`search ${this.templateData.type}`}
                query={query}
                showAdvancedFilters={this.showAdvancedFilters}
                onChangeQuery={this.onChangeQuery}
                onSearch={this.onSearch}
            />,
            this.el,
        );
    },
    destroy() {
        ReactDOM.unmountComponentAtNode(this.el);
    },
});
